
import { format } from 'date-fns';

class ApiSender {
  constructor() {
  }

  async sendPin(msisdn, language, paramsObject) {
    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    const payload = {
      msisdn,
      language,
      campaignId: paramsObject.campaignId || null,
      gclid: paramsObject.gclid || null,
      gbraid: paramsObject.gbraid || null,
      wbraid: paramsObject.wbraid || null,
      affiliateTrackerId: paramsObject.trackerId || null
    };

    try {
      const response = await fetch(`${baseUrl}/fitness/send-pin`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: result.code !== 5000
            ? result.message
            : language === 'EN' ? 'Error Happened' : 'حدث خطأ'
        };
      }

      return {
        success: result.status || false,
        message: result.message || (language === 'EN' ? 'No description available' : 'لا يوجد وصف متاح')
      };
    } catch (error) {
      console.error("Error send pin:", error.message);

      return {
        success: false,
        message: language === 'EN' ? 'Error Happened' : 'حدث خطأ'
      };
    }
  }

  async verifyPin(msisdn, language, otp, otpId, goalId, goalName, landingPageUrl, landingPageName, paramsObject) {
    const date = new Date();
    const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    const payload = {
      msisdn,
      campaignId: paramsObject.campaignId || null,
      affiliateTrackerId: paramsObject.trackerId || null,
      otp: otp,
      otpFlow: true,
      language,
      otpId: otpId,
      mfId: paramsObject.mfid || null,
      mfToken: paramsObject.mf_token || null,
      gclid: paramsObject.gclid || null,
      gbraid: paramsObject.gbraid || null,
      wbraid: paramsObject.wbraid || null,
      conversionDateTime: formattedDateTime,
      conversionGoalId: goalId,
      conversionGoalName: goalName,
      landingPageUrl,
      landingPageName,
      ...Object.fromEntries(
        Array.from({ length: 15 }, (_, i) => [`p${i + 1}`, paramsObject[`p${i + 1}`] || null])
      ),
      timezone
    };

    try {
      const response = await fetch(`${baseUrl}/fitness/verify-pin`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: result.code !== 5000
            ? result.message
            : language === 'EN' ? 'Error Happened' : 'حدث خطأ'
        };
      }

      return {
        success: result.status || false,
        message: result.message || (language === 'EN' ? 'No description available' : 'لا يوجد وصف متاح')
      };
    } catch (error) {
      console.error("Error verify pin:", error.message);

      return {
        success: false,
        message: language === 'EN' ? 'Error Happened' : 'حدث خطأ'
      };
    }
  }

  async saveHistory(landingPageUrl, paramsObject) {
    try {
      const isGoogleCampaign = paramsObject?.hasOwnProperty("gclid");
      if (!isGoogleCampaign) return;

      const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
      const endpoint = "google/visit";
      const allowedKeys = [
        "gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa", "utm_source",
        "utm_medium", "utm_campaign", "utm_term", "utm_content", "ad_group_id", "ad_group_name",
        "ad_id", "keyword_id", "keyword_text", "match_type", "clicks", "impressions", "ctr",
        "average_cpc", "conversion_date", "click_date", "geo_location", "device"
      ];

      const extraParams = Object.fromEntries(
        Object.entries(paramsObject).filter(([key]) => !allowedKeys.includes(key))
      );

      const payload = {
        ...allowedKeys.reduce((acc, key) => {
          acc[this.camelCase(key)] = paramsObject[key];
          return acc;
        }, {}),
        landingPageUrl,
        extraParams: JSON.stringify(extraParams),
      };

      await fetch(`${baseUrl}${endpoint}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error("Error in google saveHistory:", error.message);
    }
  }

  async getGoalsInfo(paramsObject) {
    const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;

    try {
      const campaignId = paramsObject.campaignId;
      if (campaignId === null || campaignId === undefined) {
        return {
          success: false,
          message: 'Campaign Not Found',
          goalId: null,
          goalName: null
        };
      }

      const response = await fetch(`${baseUrl}campaign/info?uuid=${campaignId}`, {
        method: 'GET',
        headers: { "Content-Type": "application/json" },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return {
        success: result.status || false,
        message: result.message || 'No description available',
        goalId: result.goalId,
        goalName: result.goalName
      };
    } catch (error) {
      console.error("Error get goals info:", error.message);

      return {
        success: false,
        message: 'Error Happened',
        goalId: null,
        goalName: null
      };
    }
  }

  camelCase(str) {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  }
}

export default ApiSender;  